module.exports = __webpack_public_path__ + "static/img/cdb4.ed12d9df.png";